var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.54 5.54a.65.65 0 0 1 .92 0l4 4a.65.65 0 1 1-.92.92L8 6.92l-3.54 3.54a.65.65 0 1 1-.92-.92l4-4Z",
    fill: "currentColor"
  })));
};

export { Svg16 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03LjU0MDM5IDUuNTQwMzhDNy43OTQyMyA1LjI4NjU0IDguMjA1NzggNS4yODY1NCA4LjQ1OTYzIDUuNTQwMzhMMTIuNDU5NiA5LjU0MDM4QzEyLjcxMzUgOS43OTQyMiAxMi43MTM1IDEwLjIwNTggMTIuNDU5NiAxMC40NTk2QzEyLjIwNTggMTAuNzEzNSAxMS43OTQyIDEwLjcxMzUgMTEuNTQwNCAxMC40NTk2TDguMDAwMDEgNi45MTkyNEw0LjQ1OTYzIDEwLjQ1OTZDNC4yMDU3OCAxMC43MTM1IDMuNzk0MjMgMTAuNzEzNSAzLjU0MDM5IDEwLjQ1OTZDMy4yODY1NSAxMC4yMDU4IDMuMjg2NTUgOS43OTQyMiAzLjU0MDM5IDkuNTQwMzhMNy41NDAzOSA1LjU0MDM4WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";